import { useMutation } from '@tanstack/react-query'

import { registerOrganizationChartForWorkflow } from '@src/api'
import { DefaultApiRegisterOrganizationChartForWorkflowRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useRegisterOrganizationChartForWorkflow = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (
      params: DefaultApiRegisterOrganizationChartForWorkflowRequest
    ) => registerOrganizationChartForWorkflow(axiosInstance, params),
  })
}
